/**
 * Maps a FIELD graft model node (INSTANCE_FIELD, STATIC_FIELD, or GLOBAL_FIELD)
 * to FieldData: type, name, fieldType, declaringType, isStatic.
 */

import type { Field, FieldData, TypeUsage } from '@/core/types/library.type'

import { FIELD } from '../../const/graftModelPayload.const'
import { UnifiedGraftModelTypeKey } from '../../const/unifiedGraftModelTypeKeys.const'
import { getUnifiedGraftModelType } from '../getUnifiedGraftModelType'
import { isAccessorMetadataNode } from '../isAccessorMetadataNode'

import { formatTypeUsage } from './formatTypeUsage'
import { getDeclaringType } from './getDeclaringType'
import { safeString } from './safeString'

export const mapField = (item: Field): FieldData => {
  const p = item.payload
  const typeUsage = p[FIELD.TYPE_USAGE] as TypeUsage | undefined
  const typeUsageForFormat = typeUsage ?? { payload: ['unknown', 'unknown'] }
  const kind = getUnifiedGraftModelType(item as { unifiedGraftModelType?: unknown; graftModelType?: unknown })

  const slotAfterType = p[FIELD.MODIFIER]
  const legacyDeclaringSlot = p[FIELD.DECLARING_TYPE]

  const declaringType = ((): string | undefined => {
    if (typeof legacyDeclaringSlot === 'string') {
      return safeString(legacyDeclaringSlot)
    }

    if (isAccessorMetadataNode(legacyDeclaringSlot) || isAccessorMetadataNode(slotAfterType)) {
      return undefined
    }

    return getDeclaringType(legacyDeclaringSlot)
  })()

  return {
    type: kind as FieldData['type'],
    name: safeString(p[FIELD.NAME]),
    fieldType: formatTypeUsage(typeUsageForFormat),
    fieldTypeUsage: typeUsage,
    declaringType,
    isStatic: kind === UnifiedGraftModelTypeKey.STATIC_FIELD || kind === UnifiedGraftModelTypeKey.GLOBAL_FIELD,
  }
}
